// src/redux/features/Order/orderSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { createOrder, getOrderDetails, getMyOrderList } from "./orderThunk";
import { logout } from "../Auth/authSlice"; // ✅ تغییر مسیر به authSlice

export const orderCreateSlice = createSlice({
  name: "orderCreate",
  initialState: {
    loading: false,
    success: false,
    order: {},
    error: "",
  },
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.success = false;
      state.order = {};
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.order = {};
        state.error = "";
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.order = action.payload || {};
        state.error = "";
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.order = {};
        state.error = action.payload?.response?.data?.detail || action.payload?.message || "خطا در ثبت سفارش";
      })
      .addCase(logout, (state) => { // ✅ استفاده از logout از authSlice
        state.loading = false;
        state.success = false;
        state.order = {};
        state.error = "";
      });
  },
});

export const { reset } = orderCreateSlice.actions;

export const orderDetailsSlice = createSlice({
  name: "orderDetails",
  initialState: {
    loading: false,
    order: null,
    error: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrderDetails.pending, (state) => {
        state.loading = true;
        state.order = null;
        state.error = "";
      })
      .addCase(getOrderDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.order = action.payload || null;
        state.error = "";
      })
      .addCase(getOrderDetails.rejected, (state, action) => {
        state.loading = false;
        state.order = null;
        state.error = action.payload?.response?.data?.detail || action.payload?.message || "خطا در دریافت سفارش";
      })
      .addCase(logout, (state) => {
        state.loading = false;
        state.order = null;
        state.error = "";
      });
  },
});

export const orderListMySlice = createSlice({
  name: "orderListMy",
  initialState: {
    loading: false,
    orders: [],
    error: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMyOrderList.pending, (state) => {
        state.loading = true;
        state.orders = [];
        state.error = "";
      })
      .addCase(getMyOrderList.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = Array.isArray(action.payload) ? action.payload : [];
        state.error = "";
      })
      .addCase(getMyOrderList.rejected, (state, action) => {
        state.loading = false;
        state.orders = [];
        state.error = action.payload?.response?.data?.detail || action.payload?.message || "خطا در دریافت سفارشات";
      })
      .addCase(logout, (state) => {
        state.loading = false;
        state.orders = [];
        state.error = "";
      });
  },
});